import { Client } from './client/client';

export * from './utils/field';
export * from './utils/common';

export const postInWindow: typeof import('./utils/lazy').postInWindow = async (...args) => {
	const { postInWindow } = await import('./utils/lazy');

	return postInWindow(...args);
};

export const dataToForm: typeof import('./utils/lazy').dataToForm = async (...args) => {
	const { dataToForm } = await import('./utils/lazy');

	return dataToForm(...args);
};

/**
 * Создать API клиент
 *
 * @see Api.Ext.UseExt
 */
export const createClient = <
	paths extends Api.PathsAbstract,
	UseExt extends Api.Ext.UseExt
>(
	clientOptions: Partial<Api.ClientOptions> = {},
	useExt: UseExt,
) => {
	return new Client<paths, UseExt>(clientOptions, useExt);
};
